import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Helper } from '../../common/helper';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private http: HttpClient) { }

  getOnBoardSurveyByShipAccess(access: string) {

    let paramObject = {
      'access': access
    }

    return this.http.post(Helper.API_URL() + '/api/General/GetOnBoardSurveyByShipAccess', paramObject);
  }

  submitOnBoardSurvey(data: any) {

    return this.http.post(Helper.API_URL() + '/api/General/SubmitOnBoardSurvey', data);
  }

}
